import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import LinkifyWrapper from '../LinkifyWrapper';

const LinkCell = ({
  value,
  title,
  className,
  collapsing,
}) => (
  <Table.Cell className={clsx('aridhia-link-cell', className)} title={title} collapsing={collapsing}>
    <LinkifyWrapper>
      {value}
    </LinkifyWrapper>
  </Table.Cell>
);

export default LinkCell;
